import '@fontsource-variable/big-shoulders-display';
import '@fontsource-variable/schibsted-grotesk';
import '@fontsource-variable/martian-mono';
import './styles.css';

import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

const Phone = lazy(() => import('./phone/PhoneApp'));
const Screen = lazy(() => import('./screen/ScreenApp'));
const Admin = lazy(() => import('./admin/AdminApp'));

function route() {
  const p = location.pathname.replace(/\/+$/, '');
  if (p === '/screen') return <Screen />;
  if (p === '/admin') return <Admin />;
  return <Phone />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="min-h-[100dvh] bg-ink" />}>{route()}</Suspense>
  </StrictMode>,
);
